export default __webpack_public_path__ + "static/media/MN.5d695f22.svg";